import React, { useEffect, useState, useRef } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import { CModal } from '@coreui/react';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceCommon } from '../../hooks/useAuthorizedReuestCommon';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { generateAxiosInstanceSectionFileUpload } from '../../hooks/useAuthorizedRequestForFileUpload';
import ViewImageAndText from '../../components/ViewImageAndText';
import { useNavigate } from 'react-router-dom';
import { sectionUploadCompetitiveExamFormValidation, textBookExamAddQuestion, textBookExamCreateMultipleSubjectFormValidation, textBookExamUploadSingleSubjectBlankQuestionFormValidation, textBookExamCreateSingleSubjectFormValidation, competitiveExamExamAddQuestion, competitiveExamUploadSingleSubjectBlankQuestionFormValidation, competitiveExamCreateMultipleSubjectFormValidation, competitiveExamCreateSingleSubjectFormValidation } from '../../validation/Validation';
import { ErrorMessage } from '../../validation/validationError';
import { ZodError } from 'zod';
import { getLink, ImageModal, isErrorUploadExamQuestion, isErrorQuestion, Loader, QuestionFilter, SolutionModal, validateUploadExamQuestionData, validateQuestionData } from '../../components/ModalsCommonFunctions';

const ExamUpload = () => {
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosCommon = generateAxiosInstanceCommon()
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const authorizedAxiosSectionFileUpload = generateAxiosInstanceSectionFileUpload()
    const inputRef = useRef(null);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [examType, setExamType] = useState(true);
    const [isMulti, setIsMulti] = useState("N");
    const [showAddedTextBookQuestion, setShowAddedTextBookQuestion] = useState(false);
    const [addedQuestions, setAddedQuestions] = useState([]);


    const [isMultiCompetitive, setIsMultiCompetitive] = useState("N");
    const [showAddedCompetitiveQuestion, setShowAddedCompetitiveQuestion] = useState(false);
    const [addedCompetitiveQuestions, setAddedCompetitiveQuestions] = useState([]);

    const initialExamPatternState = {
        section_id: sectionMasterId,
        subjectName: "",
        lessonName: "",
        topicName: "",
        subtopicName: "",
        exam_name: "",
        description: "",
        syllabus_structure_id: '',
        syllabus_structure_type: '',
        class_id: '',
        subject_id: '',
        lesson_id: '',
        topic_id: '',
        subtopic_id: '',
        importFile: '',
        questions: []
    }

    const [examCreateData, setExamCreateData] = useState(initialExamPatternState)
    const [errorQuestions, setErrorQuestions] = useState({})
    const [classList, setClassList] = useState([])
    const [syllabusList, setSyllabusList] = useState([]);
    const [subjectList, setSubjectList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [topicList, setTopicList] = useState([])
    const [subtopicList, setSubtopicList] = useState([])
    const [questionList, setQuestionList] = useState([])
    const [syType, setSyType] = useState()

    const [visibleSolution, setVisibleSolution] = useState(false);

    const [visible, setVisible] = useState(false)
    const [modalData, setModalData] = useState("");
    const [visibleImage, setVisibleImage] = useState(false);
    const [modalImageSrc, setModalImageSrc] = useState('');
    const [errors, setErrors] = useState([]);

    const initialCompetitiveExamPatterState = {
        section_id: sectionMasterId,
        subjectName: "",
        lessonName: "",
        topicName: "",
        subtopicName: "",
        exam_name: "",
        description: "",
        class_id: '',
        competitive_exam_id: '',
        competitive_exam_type: '',
        book_id: '',
        subject_id: '',
        lesson_id: '',
        topic_id: '',
        subtopic_id: '',
        questions: [],
        importFile: ""
    }

    const [examCreateDataCompetitiveExam, setExamCreateDataCompetitiveExam] = useState(initialCompetitiveExamPatterState)
    const [errorQuestionsCompetitiveExam, setErrorQuestionsCompetitiveExam] = useState({})
    const [competitiveExamNameList, setCompetitiveExamNameList] = useState([]);
    const [competitiveExamBookList, setCompetitiveExamBookList] = useState([])
    const [subjectListCompetitiveExam, setSubjectListCompetitiveExam] = useState([])
    const [lessonListCompetitiveExam, setLessonListCompetitiveExam] = useState([])
    const [topicListCompetitiveExam, setTopicListCompetitiveExam] = useState([])
    const [subtopicListCompetitiveExam, setSubtopicListCompetitiveExam] = useState([])
    const [questionListCompetitiveExam, setQuestionListCompetitiveExam] = useState([])
    const [syTypeCompetitiveExam, setSyTypeCompetitiveExam] = useState()
    const [errorsCompetitiveExam, setErrorsCompetitiveExam] = useState([])
    const inputRefCompetitiveExam = useRef(null);

    const onViewImage = (imgSrc) => {
        setModalImageSrc(imgSrc);
        setVisibleImage(true);
    };

    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        const apiUrl = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setClassList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.log("Error fetching data: ", errorMsg);
            });
    }, [])

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === "subtopic_id") {
            const selectedOption = e.target.options[e.target.selectedIndex];
            const selectedSubtopicName = selectedOption.getAttribute('data-subtopic-name');
            setExamCreateData((prevData) => {
                return {
                    ...prevData,
                    [name]: value,
                    subtopicName: selectedSubtopicName
                }
            })
        } else {
            setExamCreateData((prevData) => {
                return {
                    ...prevData,
                    [name]: value
                }
            })
        }

        // Clear the error for the specific field being edited
        if (value.trim() !== '') {
            setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }
    }

    useEffect(() => {
        setExamCreateData((prevData) => {
            return {
                ...prevData,
                questions: []
            }
        })
        setAddedQuestions([]);
    }, [isMulti])

    const handleClassChange = (e) => {
        setSyType();
        setSubjectList([]);
        setLessonList([]);
        setTopicList([]);
        setSubtopicList([]);
        setQuestionList([]);

        const { name, value } = e.target;
        setExamCreateData((prevData) => {
            return {
                ...prevData,
                [name]: value,
                syllabus_structure_id: '',
                syllabus_structure_type: '',
                subject_id: '',
                lesson_id: '',
                topic_id: '',
                subtopic_id: '',
                subjectName: "",
                lessonName: "",
                topicName: "",
                subtopicName: ""
            }
        })

        getSyllabusList(e.target.value)

        // Clear the error for the specific field being edited
        if (value.trim() !== '') {
            setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }
    }

    const handleUploadQuestion = async (e) => {
        const file = e.target.files[0];

        if (!file) {
            setExamCreateData(prevData => {
                return {
                    ...prevData,
                    importFile: ""
                }
            })
            return;
        }

        const fileExtension = file.name.split('.').pop().toLowerCase();
        const body = new FormData();
        body.append('file', file);

        if (fileExtension === "xlsx") {
            setLoading(true);
            if (file.size) {
                try {
                    const apiUrl = "exams-upload-file";
                    const response = await authorizedAxiosSectionFileUpload.post(apiUrl, body);
                    setErrorQuestions(validateUploadExamQuestionData(response.data.questions, true, setQuestionList));
                    setExamCreateData(prevData => {
                        return {
                            ...prevData,
                            importFile: "true"
                        }
                    })

                    if (file.name.trim().length !== 0) {
                        setErrors(prevErrors =>
                            prevErrors.filter(error => error.path[0] !== e.target.name)
                        );
                    }
                } catch (error) {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire({ text: errorMsg });
                } finally {
                    setLoading(false);
                }
            } else {
                Swal.fire({ text: "File size is zero!" });
            }
        } else if (fileExtension === "docx") {
            setLoading(true);
            if (file.size) {
                try {
                    const link = await getLink(e.target.name, body);
                    if (!link) throw new Error('Link not generated');

                    const endpoint = "convert-docx-for-exam";
                    const payload = { "wordFilePath": link };

                    const response = await authorizedAxiosSectionFileUpload.post(endpoint, payload);
                    setErrorQuestions(validateUploadExamQuestionData(response.data.questions, true, setQuestionList));
                    // setErrorQuestions(validateQuestionData(response.data.convertedData, true, setQuestionList));

                    setExamCreateData(prevData => {
                        return {
                            ...prevData,
                            importFile: "true"
                        }
                    })

                    if (file.name.trim().length !== 0) {
                        setErrors(prevErrors =>
                            prevErrors.filter(error => error.path[0] !== e.target.name)
                        );
                    }
                } catch (error) {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire({ text: errorMsg });
                } finally {
                    setLoading(false);
                }
            } else {
                Swal.fire({ text: "File size is zero!" });
            }
        } else {
            Swal.fire({ text: "Only xlsx & docx files are supported" });
        }
    };

    const getSyllabusList = (id) => {
        const apiUrlForSyllabus = `/get-all-syllabus-structure-grade-medium-board-wise?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&instituteGradeMasterId=${id}`;
        authorizedAxiosCommon && authorizedAxiosCommon.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                setSyllabusList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.log("Error fetching data: ", errorMsg);
            });
    }

    const handleSyllabusChange = (e) => {
        const { name, value } = e.target;
        const id = value.slice(0, -1); // Extracts the ID
        const type = value.slice(-1);  // Extracts the type

        // Reset lists and set syllabus type
        setSyType(type);
        setLessonList([]);
        setTopicList([]);
        setSubtopicList([]);

        // Update exam data state
        setExamCreateData(prevData => ({
            ...prevData,
            [name]: id,
            syllabus_structure_type: type,
            subject_id: '',
            lesson_id: '',
            topic_id: '',
            subtopic_id: '',
            subjectName: "",
            lessonName: "",
            topicName: "",
            subtopicName: ""
        }));

        // Clear error for the specific field if the ID is not empty
        if (id.trim() !== '') {
            setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }

        // Define API URLs and axios instances based on type
        const apiUrls = {
            I: `get-institute-syllabus-structure-Wise-institute-subjects?id=${id}`,
            A: `/syllabus-structure-wise-subjects?id=${id}`,
            B: `/get-section-syllabus-structure-Wise-section-subjects?id=${id}`
        };

        const axiosInstances = {
            I: authorizedAxiosInstitute,
            A: authorizedAxios,
            B: authorizedAxiosSection
        };

        const apiUrl = apiUrls[type];
        const axiosInstance = axiosInstances[type];

        // Fetch data from the respective API if the instance and URL exist
        if (axiosInstance && apiUrl) {
            axiosInstance.get(apiUrl)
                .then(response => {
                    setSubjectList(response.data.result);
                })
                .catch(error => {
                    setSubjectList([]);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    };

    const handleSubjectChange = (e) => {
        const { name, value } = e.target;
        const selectedOption = e.target.options[e.target.selectedIndex];
        const selectedSubjectName = selectedOption.getAttribute('data-subject-name');

        setExamCreateData((prevData) => ({
            ...prevData,
            [name]: value,
            subjectName: selectedSubjectName,
            lesson_id: '',
            topic_id: '',
            subtopic_id: '',
            lessonName: "",
            topicName: "",
            subtopicName: "",
        }));

        setTopicList([]);
        setSubtopicList([]);

        // Define API URLs and axios instances based on syType
        const apiUrls = {
            B: `/get-section-subject-wise-section-lesson?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&sectionSyllabusStructureMasterId=${examCreateData.syllabus_structure_id}&instituteSubjectMasterId=${value}`,
            I: `get-institute-subject-wise-institute-lesson?instituteMasterId=${instituteMasterId}&instituteSyllabusStructureMasterId=${examCreateData.syllabus_structure_id}&instituteSubjectMasterId=${value}`,
            A: `/subject-wise-lesson?syllabusStructureMasterId=${examCreateData.syllabus_structure_id}&subjectMasterId=${value}`
        };

        const axiosInstances = {
            B: authorizedAxiosSection,
            I: authorizedAxiosInstitute,
            A: authorizedAxios
        };

        const apiUrl = apiUrls[syType];
        const axiosInstance = axiosInstances[syType];

        if (axiosInstance && apiUrl) {
            axiosInstance.get(apiUrl)
                .then(response => {
                    setLessonList(response.data.result);
                })
                .catch(error => {
                    setLessonList([]);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Error: ", errorMsg);
                });
        }

        if (value.trim() !== '') {
            setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }
    };

    const handleLessonChange = (e) => {
        const { name, value } = e.target;
        const selectedOption = e.target.options[e.target.selectedIndex];
        const selectedLessonName = selectedOption.getAttribute('data-lesson-name'); // Retrieve lesson name

        // Update state with lesson name and reset related fields
        setExamCreateData((prevData) => ({
            ...prevData,
            [name]: value,
            lessonName: selectedLessonName,
            topic_id: '',
            subtopic_id: '',
            topicName: "",
            subtopicName: ""
        }));

        setSubtopicList([]); // Reset subtopic list

        // Define API URLs and axios instances based on syType
        const apiUrls = {
            I: `/get-institute-lesson-wise-institute-sub-topic?id=${value}`,
            A: `/lesson-wise-topic?id=${value}`,
            B: `/get-section-lesson-wise-section-sub-topic?id=${value}`
        };

        const axiosInstances = {
            I: authorizedAxiosInstitute,
            A: authorizedAxios,
            B: authorizedAxiosSection
        };

        const apiUrl = apiUrls[syType];
        const axiosInstance = axiosInstances[syType];

        if (axiosInstance && apiUrl) {
            axiosInstance.get(apiUrl)
                .then(response => {
                    setTopicList(response.data.result);
                })
                .catch(error => {
                    setTopicList([]);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Error: ", errorMsg);
                });
        }

        if (value.trim() !== '') {
            setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }
    };


    const handleTopicChange = (e) => {
        const { name, value } = e.target;
        const selectedOption = e.target.options[e.target.selectedIndex];
        const selectedTopicName = selectedOption.getAttribute('data-topic-name'); // Retrieve topic name

        setExamCreateData((prevData) => ({
            ...prevData,
            [name]: value,
            topicName: selectedTopicName,
            subtopic_id: '',
            subtopicName: "",
        }));

        // Define API URLs and axios instances based on syType
        const apiUrls = {
            I: `/get-institute-sub-topic-master?instituteMasterId=${instituteMasterId}&instituteSyllabusStructureMasterId=${examCreateData.syllabus_structure_id}&instituteSubjectMasterId=${examCreateData.subject_id}&instituteLessonMasterId=${examCreateData.lesson_id}&instituteTopicMasterId=${value}`,
            A: `/get-sub-topic-master-list?syllabusStructureId=${examCreateData.syllabus_structure_id}&subjectMasterId=${examCreateData.subject_id}&lessonId=${examCreateData.lesson_id}&topicId=${value}`,
            B: `/get-section-sub-topic-master?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&sectionSyllabusStructureMasterId=${examCreateData.syllabus_structure_id}&instituteSubjectMasterId=${examCreateData.subject_id}&sectionLessonMasterId=${examCreateData.lesson_id}&sectionTopicMasterId=${value}`
        };

        const axiosInstances = {
            I: authorizedAxiosInstitute,
            A: authorizedAxios,
            B: authorizedAxiosSection
        };

        const apiUrl = apiUrls[syType];
        const axiosInstance = axiosInstances[syType];

        if (axiosInstance && apiUrl) {
            axiosInstance.get(apiUrl)
                .then(response => {
                    setSubtopicList(response.data.result);
                })
                .catch(error => {
                    setSubtopicList([]);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Error: ", errorMsg);
                });
        }
    };

    const handleQuestionErrors = (errorQuestionIds, questionList) => {
        const matchedQuestionIndices = errorQuestionIds
            .map(id => {
                const index = questionList.findIndex(question => question.q_id === id);
                return index !== -1 ? (index + 1).toString() : null;
            })
            .filter(index => index !== null)
            .join(', ');

        const message = `Errors found in questions at indices: ${matchedQuestionIndices}`;
        Swal.fire({ text: message });
    };

    const handleQuestionUpdate = (questionsArray, setExamData, addedQuestions, setAddedQuestions) => {
        setExamData(prevState => {
            const newQuestionIds = [...prevState.questions];
            let updatedAddedQuestions = [...addedQuestions];

            questionsArray.forEach(({ subject_id, lesson_id, topic_id, subtopic_id, question }) => {
                const existingIndex = newQuestionIds.findIndex(
                    item => item.subject_id === subject_id && item.lesson_id === lesson_id && item.topic_id === topic_id && item.subtopic_id === subtopic_id
                );

                if (existingIndex !== -1) {
                    const existingItem = newQuestionIds[existingIndex];
                    const questionIndex = existingItem.question_ids.findIndex(q => q.q_id === question.q_id);

                    if (questionIndex !== -1) {
                        // Question ID is already present, remove it
                        const updatedQuestions = existingItem.question_ids.filter(q => q.q_id !== question.q_id);
                        updatedAddedQuestions = updatedAddedQuestions.filter(q => q.q_id !== question.q_id);

                        if (updatedQuestions.length === 0) {
                            // If no question IDs remain, remove the entire object
                            newQuestionIds.splice(existingIndex, 1);
                        } else {
                            // Otherwise, update the object with the remaining question IDs
                            newQuestionIds[existingIndex] = { ...existingItem, question_ids: updatedQuestions };
                        }
                    } else {
                        // Question ID is not present, add it
                        newQuestionIds[existingIndex] = { ...existingItem, question_ids: [...existingItem.question_ids, question] };
                        updatedAddedQuestions.push(question); // Add the question to addedQuestions
                    }
                } else {
                    // Object with subject_id, lesson_id, topic_id, and subtopic_id doesn't exist, add a new one
                    newQuestionIds.push({
                        subject_id,
                        lesson_id,
                        topic_id,
                        subtopic_id,
                        question_ids: [question]
                    });
                    updatedAddedQuestions.push(question); // Add the question to addedQuestions
                }
            });

            // Update addedQuestions state
            setAddedQuestions(updatedAddedQuestions);

            return { ...prevState, questions: newQuestionIds };
        });
    };

    const isQuestionSelected = (question, addedQuestions) => {
        return addedQuestions.some(addedQuestion => addedQuestion.q_id === question.q_id);
    };

    const handleAddSingleQuestion = async (question, examData, setExamData, addedQuestions, setAddedQuestions) => {
        if (!isQuestionSelected(question, addedQuestions)) {
            try {
                if (examType === true) {
                    await textBookExamAddQuestion.parseAsync(examData);
                    setErrors([]);
                } else {
                    await competitiveExamExamAddQuestion.parseAsync(examData)
                    setErrorsCompetitiveExam([]);
                }

                handleQuestionUpdate([{
                    subject_id: examData.subject_id,
                    lesson_id: examData.lesson_id,
                    topic_id: examData.topic_id,
                    subtopic_id: examData.subtopic_id,
                    question: {
                        ...question,
                        subjectName: examData.subjectName,
                        lessonName: examData.lessonName,
                        topicName: examData.topicName,
                        subtopicName: examData.subtopicName
                    }
                }], setExamData, addedQuestions, setAddedQuestions)
            } catch (error) {
                if (error instanceof ZodError) {
                    setErrors(error.errors);
                }
            }
        }
    }

    const getMissingQuestions = (questionList, examData) => {
        const existingQIds = new Set(); // Using Set for O(1) lookups

        // Populate the Set with q_ids from examCreateData
        for (const questionBlock of examData.questions) {
            if (questionBlock.question_ids && questionBlock.question_ids.length > 0) {
                for (const question of questionBlock.question_ids) {
                    existingQIds.add(question.q_id); // Add each q_id to the Set
                }
            }
        }

        // Find q_ids from questionList that are not in examCreateData and return objects
        const missingQuestions = questionList
            .filter(question => !existingQIds.has(question.q_id)) // Filter out existing q_ids
            .map(question => ({
                subject_id: examData.subject_id,
                lesson_id: examData.lesson_id,
                topic_id: examData.topic_id,
                subtopic_id: examData.subtopic_id,
                question: {
                    ...question,
                    subjectName: examData.subjectName,
                    lessonName: examData.lessonName,
                    topicName: examData.topicName,
                    subtopicName: examData.subtopicName
                }
            }));

        return missingQuestions;
    };

    const removeQuestionsFromList = (questionList, setExamData, setAddedQuestions) => {
        // Extract q_ids from the questionList
        const qIdsToRemove = questionList.map(question => question.q_id);

        // Update examcreateData.questions state
        setExamData(prevData => ({
            ...prevData,
            questions: prevData.questions
                .map(question => ({
                    ...question,
                    question_ids: question.question_ids.filter(q => !qIdsToRemove.includes(q.q_id))
                }))
                .filter(question => question.question_ids.length > 0)  // Remove question if no question_ids left
        }));

        // Update addedQuestions state
        setAddedQuestions(prevAddedQuestions =>
            prevAddedQuestions.filter(question => !qIdsToRemove.includes(question.q_id))
        );
    };


    const handleSelectAllClick = async (questions, examData, setExamData, addedQuestions, setAddedQuestions) => {
        const missingQuestions = getMissingQuestions(questions);
        const AllformattedQuestions = questions.map((question) => ({
            subject_id: examData.subject_id,
            lesson_id: examData.lesson_id,
            topic_id: examData.topic_id,
            subtopic_id: examData.subtopic_id,
            question: {
                ...question,
                subjectName: examData.subjectName,
                lessonName: examData.lessonName,
                topicName: examData.topicName,
                subtopicName: examData.subtopicName
            }
        }));

        if (missingQuestions.length === questions.length) {
            try {
                if (examType === true) {
                    await textBookExamAddQuestion.parseAsync(examData);
                    setErrors([]);
                } else {
                    await competitiveExamExamAddQuestion.parseAsync(examData)
                    setErrorsCompetitiveExam([]);
                }

                handleQuestionUpdate(AllformattedQuestions, setExamData, addedQuestions, setAddedQuestions);
            } catch (error) {
                if (error instanceof ZodError) {
                    setErrors(error.errors);
                }
            }
        } else if (missingQuestions.length === 0) {
            removeQuestionsFromList(questions, setExamData, setAddedQuestions);
        } else {
            try {
                if (examType === true) {
                    await textBookExamAddQuestion.parseAsync(examData);
                    setErrors([]);
                } else {
                    await competitiveExamExamAddQuestion.parseAsync(examData)
                    setErrorsCompetitiveExam([]);
                }

                handleQuestionUpdate(missingQuestions, setExamData, addedQuestions, setAddedQuestions);
            } catch (error) {
                if (error instanceof ZodError) {
                    setErrors(error.errors);
                }
            }
        }
    };

    const areAllQuestionsSelected = (questions, addedQuestions) => {
        // If either array is empty, return false
        if (questions.length === 0 || addedQuestions.length === 0) {
            return false;
        }

        // Create a Set of q_id from the addedQuestions array for quick lookup
        const addedQuestionIdsSet = new Set(addedQuestions.map(addedQ => addedQ.q_id));

        // Check if every q_id in questions exists in the addedQuestions Set
        return questions.every(question => addedQuestionIdsSet.has(question.q_id));
    }

    const handleSelectAllClickTextBookQuestion = (setExamData, setAddedQuestions) => {
        setExamCreateData((prevData) => {
            return {
                ...prevData,
                questions: []
            }
        });
        setAddedQuestions([]);
    }

    const removeQuestion = (qIdToRemove, setExamData, setAddedQuestions) => {
        try {
            setExamData(prevData => ({
                ...prevData,
                questions: prevData.questions
                    .map(question => ({
                        ...question,
                        question_ids: question.question_ids.filter(q => q.q_id !== qIdToRemove)
                    }))
                    .filter(question => question.question_ids.length > 0)  // Remove question if no question_ids left
            }));

            setAddedQuestions(prevAddedQuestions =>
                prevAddedQuestions.filter(question => question.q_id !== qIdToRemove)
            );

            return true;
        } catch (error) {
            console.error('Error in removing question:', error);
            return false; // Return false if there's an error
        }
    };

    const deleteQuestion = (id, setExamData, setAddedQuestions) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            const isDeleted = removeQuestion(id, setExamData, setAddedQuestions);
            isDeleted ? Swal.fire({ text: "Question deleted successfully" }) : Swal.fire({ text: "Something went wrong!" });
        }
    }

    const isQuestionIdPresent = (id, examData) => {
        const qIdMap = new Set(); // Using Set for O(1) lookups

        // Loop through the questions array and add q_id to the Set
        for (const questionBlock of examData.questions) {
            if (questionBlock.question_ids && questionBlock.question_ids.length > 0) {
                for (const question of questionBlock.question_ids) {
                    qIdMap.add(question.q_id); // Add each q_id to the Set
                }
            }
        }

        // Check if the id exists in the qIdMap
        return qIdMap.has(id); // O(1) lookup time
    };



    const createTextBookExam = async () => {
        try {
            if (examCreateData.questions.length === 0) {
                await textBookExamUploadSingleSubjectBlankQuestionFormValidation.parseAsync(examCreateData);
            } else {
                if (isMulti === "Y") {
                    await textBookExamCreateMultipleSubjectFormValidation.parseAsync(examCreateData);
                } else {
                    await textBookExamCreateSingleSubjectFormValidation.parseAsync(examCreateData);
                }
            }

            setErrors([]);
            setLoading(true);
            const questionIds = validateUploadExamQuestionData(addedQuestions, false);
            if (questionIds.errorCount > 0) {
                handleQuestionErrors(questionIds.errorquestionIds, questionList);
                setLoading(false);
                return;
            }

            const apiUrl = `/exams-v2`;
            const { subject_id, lesson_id, topic_id, subtopic_id, importFile, subjectName, lessonName, topicName, subtopicName, ...rest } = examCreateData;

            const data = {
                ...rest,
                exam_type: "U",
                isMulti
            };
            const response = await authorizedAxiosSection.post(apiUrl, data);

            setExamCreateData(initialExamPatternState);
            setSyllabusList([]);
            setSubjectList([]);
            setLessonList([]);
            setTopicList([]);
            setSubtopicList([]);
            setAddedQuestions([]);
            setShowAddedTextBookQuestion(false);
            setIsMulti("N");
            setErrors([]);
            setSyType();
            setQuestionList([]);
            setErrorQuestions({});
            inputRef.current.value = null;

            Swal.fire({ text: response.data.message });
        } catch (error) {
            if (error instanceof ZodError) {
                setErrors(error.errors);
            } else {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire({ text: errorMsg });
            }
        } finally {
            setLoading(false);
        }
    };



    // Competitive Exam Fuctions
    const handleInputChangeCompetitiveExam = (e) => {
        const { name, value } = e.target;

        if (name === "subtopic_id") {
            const selectedOption = e.target.options[e.target.selectedIndex];
            const selectedSubtopicName = selectedOption.getAttribute('data-subtopic-name');
            setExamCreateDataCompetitiveExam((prevData) => {
                return {
                    ...prevData,
                    [name]: value,
                    subtopicName: selectedSubtopicName
                }
            })
        } else {
            setExamCreateDataCompetitiveExam((prevData) => {
                return {
                    ...prevData,
                    [name]: value
                }
            })
        }

        // Clear the error for the specific field being edited
        if (value.trim() !== '') {
            setErrorsCompetitiveExam(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }
    }

    useEffect(() => {
        setExamCreateDataCompetitiveExam((prevData) => {
            return {
                ...prevData,
                questions: []
            }
        })
        setAddedCompetitiveQuestions([]);
    }, [isMultiCompetitive])

    const handleClassChangeCompetitveExam = (e) => {
        const { name, value } = e.target;
        setExamCreateDataCompetitiveExam((prevData) => {
            return {
                ...prevData,
                [name]: value,
                competitive_exam_id: '',
                competitive_exam_type: '',
                book_id: '',
                subject_id: '',
                lesson_id: '',
                topic_id: '',
                subtopic_id: '',
            }
        })

        if (value.trim() !== '') {
            setErrorsCompetitiveExam(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }

        setSyTypeCompetitiveExam();
        setSubjectListCompetitiveExam([]);
        setLessonListCompetitiveExam([]);
        setTopicListCompetitiveExam([]);
        setSubtopicListCompetitiveExam([]);
        setCompetitiveExamBookList([]);
        getCompetitiveExamNameList(value)
    }

    const getCompetitiveExamNameList = (id) => {
        const apiUrl = `/get-institute-grade-wise-competitive-exam-name?instituteMasterId=${instituteMasterId}&instituteGradeMasterId=${id}`;
        authorizedAxiosCommon && authorizedAxiosCommon.get(apiUrl)
            .then(response => {
                setCompetitiveExamNameList(response.data.result)
            })
            .catch(error => {
                setCompetitiveExamNameList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.log("Fetching Error data: ", errorMsg);
            });
    }

    const handleCompetitiveExamNameChange = (e) => {
        const { name, value } = e.target;

        // Reset lists
        setCompetitiveExamBookList([]);
        setSubjectListCompetitiveExam([]);
        setLessonListCompetitiveExam([]);
        setTopicListCompetitiveExam([]);
        setSubtopicListCompetitiveExam([]);

        const id = value.slice(0, -1); // Extract id (all characters except last)
        const type = value.slice(-1); // Extract last character (type)

        setSyTypeCompetitiveExam(type);

        // Update state with the extracted values and reset related fields
        setExamCreateDataCompetitiveExam(prevData => ({
            ...prevData,
            [name]: id,
            competitive_exam_type: type,
            book_id: '',
            subject_id: '',
            lesson_id: '',
            topic_id: '',
            subtopic_id: '',
        }));

        if (id.trim() !== '') {
            setErrorsCompetitiveExam(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }

        // Define API URLs based on the type
        const apiUrls = {
            A: `/get-competitive-exam-book-master?competitiveExamNameMasterId=${id}`,
            I: `/get-institute-competitive-exam-book-master?instituteCompetitiveExamNameMasterId=${id}`
        };

        // Select the appropriate axios instance based on the type
        const axiosInstances = {
            A: authorizedAxios,
            I: authorizedAxiosInstitute
        };

        const apiUrl = apiUrls[type];
        const axiosInstance = axiosInstances[type];

        // Make the API call if the axios instance and URL are available
        if (axiosInstance && apiUrl) {
            axiosInstance.get(apiUrl)
                .then(response => {
                    setCompetitiveExamBookList(response.data.data);
                })
                .catch(error => {
                    setCompetitiveExamBookList([]);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Error: ", errorMsg);
                });
        }
    };

    const handleCompetitiveExamBookChange = (e) => {
        // Extract name and value from e.target
        const { name, value } = e.target;

        // Reset lesson, topic, and subtopic lists
        setLessonListCompetitiveExam([]);
        setTopicListCompetitiveExam([]);
        setSubtopicListCompetitiveExam([]);

        // Update state with the selected value and reset related fields
        setExamCreateDataCompetitiveExam(prevData => ({
            ...prevData,
            [name]: value,
            subject_id: '',
            lesson_id: '',
            topic_id: '',
            subtopic_id: '',
        }));

        // Clear the error for the specific field being edited
        if (value.trim() !== '') {
            setErrorsCompetitiveExam(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }

        // Define API URLs and axios instances based on syType
        const apiUrls = {
            I: `/get-institute-competitive-exam-book-wise-subject?instituteCompetitiveExamBookMasterId=${value}`,
            A: `/get-competitive-exam-book-wise-subject?competitiveExamBookMasterId=${value}`
        };

        const axiosInstances = {
            I: authorizedAxiosInstitute,
            A: authorizedAxios
        };

        const apiUrl = apiUrls[syTypeCompetitiveExam];
        const axiosInstance = axiosInstances[syTypeCompetitiveExam];

        // Fetch subject list if axios instance and URL are available
        if (axiosInstance && apiUrl) {
            axiosInstance.get(apiUrl)
                .then(response => {
                    setSubjectListCompetitiveExam(response.data.result);
                })
                .catch(error => {
                    setSubjectListCompetitiveExam([]);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Error: ", errorMsg);
                });
        }
    };

    const handleSubjectChangeCompetitiveExam = (e) => {
        const { name, value } = e.target;
        const selectedOption = e.target.options[e.target.selectedIndex];
        const selectedSubjectName = selectedOption.getAttribute('data-subject-name');

        // Update the state with the selected subject and reset lesson, topic, and subtopic
        setExamCreateDataCompetitiveExam(prevData => ({
            ...prevData,
            [name]: value,
            subjectName: selectedSubjectName,
            lesson_id: '',
            topic_id: '',
            subtopic_id: '',
            lessonName: "",
            topicName: "",
            subtopicName: ""
        }));

        // Clear specific field errors if value is not empty
        if (value.trim() !== '') {
            setErrorsCompetitiveExam(prevErrors =>
                prevErrors.filter(error => error.path[0] !== name)
            );
        }

        // Reset topic and subtopic lists
        setTopicListCompetitiveExam([]);
        setSubtopicListCompetitiveExam([]);

        // API URLs based on `syTypeCompetitiveExam`
        const apiUrls = {
            I: `/get-institute-competitive-lesson-master?instituteMasterId=${instituteMasterId}&instituteCompetitiveExamBookMasterId=${examCreateDataCompetitiveExam.book_id}&instituteSubjectMasterId=${value}`,
            A: `/get-competitive-lesson?competitiveExamBookMasterId=${examCreateDataCompetitiveExam.book_id}&subjectMasterId=${value}`
        };

        // Select the appropriate Axios instance and URL based on `syTypeCompetitiveExam`
        const axiosInstances = {
            I: authorizedAxiosInstitute,
            A: authorizedAxios
        };

        const apiUrl = apiUrls[syTypeCompetitiveExam];
        const axiosInstance = axiosInstances[syTypeCompetitiveExam];

        // Fetch the lesson list based on the subject
        if (axiosInstance && apiUrl) {
            axiosInstance.get(apiUrl)
                .then(response => {
                    setLessonListCompetitiveExam(response.data.result || []);
                })
                .catch(error => {
                    setLessonListCompetitiveExam([]);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Fetching Error data: ", errorMsg);
                });
        }
    };


    const handleUploadCompetitiveQuestion = async (e) => {
        const file = e.target.files[0];

        if (!file) {
            setExamCreateDataCompetitiveExam(prevData => ({
                ...prevData,
                importFile: ""
            }));
            return;
        }

        const fileExtension = file.name.split('.').pop().toLowerCase();
        const body = new FormData();
        body.append('file', file);

        if (fileExtension === "xlsx") {
            setLoading(true);
            if (file.size > 0) {
                try {
                    const apiUrl = "exams-upload-file";
                    const response = await authorizedAxiosSectionFileUpload.post(apiUrl, body);
                    // setQuestionListCompetitiveExam(response.data.questions);
                    setErrorQuestionsCompetitiveExam(validateUploadExamQuestionData(response.data.questions, true, setQuestionListCompetitiveExam));
                    setExamCreateDataCompetitiveExam(prevData => ({
                        ...prevData,
                        importFile: "true"
                    }));

                    if (file.name.trim().length !== 0) {
                        setErrorsCompetitiveExam(prevErrors =>
                            prevErrors.filter(error => error.path[0] !== e.target.name)
                        );
                    }
                } catch (error) {
                    const errorMsg = error.response?.data?.error || "Something went wrong!";
                    Swal.fire({ text: errorMsg });
                } finally {
                    setLoading(false);
                }
            } else {
                Swal.fire({ text: "File size is zero!" });
            }
        } else if (fileExtension === "docx") {
            setLoading(true);
            if (file.size > 0) {
                try {
                    const link = await getLink(e.target.name, body);
                    if (!link) throw new Error('Link not generated');

                    const endpoint = "convert-docx-for-exam";
                    const payload = { "wordFilePath": link };

                    const response = await authorizedAxiosSectionFileUpload.post(endpoint, payload);
                    setErrorQuestionsCompetitiveExam(validateUploadExamQuestionData(response.data.questions, true, setQuestionListCompetitiveExam));
                    setExamCreateDataCompetitiveExam(prevData => ({
                        ...prevData,
                        importFile: "true"
                    }));

                    if (file.name.trim().length !== 0) {
                        setErrorsCompetitiveExam(prevErrors =>
                            prevErrors.filter(error => error.path[0] !== e.target.name)
                        );
                    }
                } catch (error) {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire({ text: errorMsg });
                } finally {
                    setLoading(false);
                }
            } else {
                Swal.fire({ text: "File size is zero!" });
            }
        } else {
            Swal.fire({ text: "Only xlsx & docx files are supported" });
        }
    }

    const handleCompetitiveExamLessonChange = (e) => {
        const { name, value } = e.target;
        const selectedOption = e.target.options[e.target.selectedIndex];
        const selectedLessonName = selectedOption.getAttribute('data-lesson-name'); // Retrieve lesson name

        setSubtopicListCompetitiveExam([]);

        // Update state with the selected lesson and reset related fields
        setExamCreateDataCompetitiveExam(prevData => ({
            ...prevData,
            [name]: value,
            lessonName: selectedLessonName,
            topic_id: '',
            subtopic_id: '',
            topicName: "",
            subtopicName: ""
        }));

        // Define API URLs based on syType
        const apiUrls = {
            I: `/get-institute-competitive-topic-master?instituteMasterId=${instituteMasterId}&instituteCompetitiveLessonMasterId=${value}`,
            A: `/get-competitive-topic?competitiveLessonMasterId=${value}`
        };

        const axiosInstances = {
            I: authorizedAxiosInstitute,
            A: authorizedAxios
        };

        const apiUrl = apiUrls[syTypeCompetitiveExam];
        const axiosInstance = axiosInstances[syTypeCompetitiveExam];

        // Fetch topic list if axios instance and URL are available
        if (axiosInstance && apiUrl) {
            axiosInstance.get(apiUrl)
                .then(response => {
                    setTopicListCompetitiveExam(response.data.result || []);
                })
                .catch(error => {
                    setTopicListCompetitiveExam([]);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Error: ", errorMsg);
                });
        }
    };

    const handleCompetitiveExamTopicChange = (e) => {
        const { name, value } = e.target;
        const selectedOption = e.target.options[e.target.selectedIndex];
        const selectedTopicName = selectedOption.getAttribute('data-topic-name');

        // Update the state with the selected topic and reset subtopic
        setExamCreateDataCompetitiveExam(prevData => ({
            ...prevData,
            [name]: value,
            topicName: selectedTopicName,
            subtopic_id: '',
            subtopicName: "",
        }));

        // Define API URLs based on syType
        const apiUrls = {
            I: `/get-institute-competitive-sub-topic-master?instituteMasterId=${instituteMasterId}&instituteCompetitiveExamNameMasterId=${examCreateDataCompetitiveExam.competitive_exam_id}&instituteCompetitiveExamBookMasterId=${examCreateDataCompetitiveExam.book_id}&instituteCompetitiveLessonMasterId=${examCreateDataCompetitiveExam.lesson_id}&instituteCompetitiveTopicMasterId=${value}`,
            A: `/get-competitive-sub-topic?competitiveExamNameMasterId=${examCreateDataCompetitiveExam.competitive_exam_id}&competitiveExamBookMasterId=${examCreateDataCompetitiveExam.book_id}&competitiveLessonMasterId=${examCreateDataCompetitiveExam.lesson_id}&competitiveTopicMasterId=${value}`
        };

        // Define axios instances for each case
        const axiosInstances = {
            I: authorizedAxiosInstitute,
            A: authorizedAxios
        };

        const apiUrl = apiUrls[syTypeCompetitiveExam];
        const axiosInstance = axiosInstances[syTypeCompetitiveExam];

        // Fetch subtopic list if axios instance and URL are available
        if (axiosInstance && apiUrl) {
            axiosInstance.get(apiUrl)
                .then(response => {
                    setSubtopicListCompetitiveExam(response.data.result || []);
                })
                .catch(error => {
                    setSubtopicListCompetitiveExam([]);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Error: ", errorMsg);
                });
        }
    };

    const createCompetitiveExam = async () => {
        try {
            if (examCreateDataCompetitiveExam.questions.length === 0) {
                await competitiveExamUploadSingleSubjectBlankQuestionFormValidation.parseAsync(examCreateDataCompetitiveExam);
            } else {
                if (isMultiCompetitive === "Y") {
                    await competitiveExamCreateMultipleSubjectFormValidation.parseAsync(examCreateDataCompetitiveExam);
                } else {
                    await competitiveExamCreateSingleSubjectFormValidation.parseAsync(examCreateDataCompetitiveExam);
                }
            }

            setErrorsCompetitiveExam([]);
            setLoading(true);

            const questionIds = validateUploadExamQuestionData(addedCompetitiveQuestions, false);
            if (questionIds.errorCount > 0) {
                handleQuestionErrors(questionIds.errorquestionIds, questionListCompetitiveExam);
                setLoading(false);
                return;
            }

            const apiUrl = `/competitive-exam-v2`;
            const { subject_id, lesson_id, topic_id, subtopic_id, importFile, subjectName, lessonName, topicName, subtopicName, ...rest } = examCreateDataCompetitiveExam;

            const data = {
                ...rest,
                exam_type: "U",
                isMulti: isMultiCompetitive
            };
            const response = await authorizedAxiosSection.post(apiUrl, data);


            setExamCreateDataCompetitiveExam(initialCompetitiveExamPatterState);
            setQuestionListCompetitiveExam([]);
            setCompetitiveExamNameList([]);
            setCompetitiveExamBookList([]);
            setSubjectListCompetitiveExam([]);
            setLessonListCompetitiveExam([]);
            setTopicListCompetitiveExam([]);
            setSubtopicListCompetitiveExam([]);
            setAddedCompetitiveQuestions([]);
            setShowAddedCompetitiveQuestion(false);
            setIsMultiCompetitive("N");
            setErrorQuestionsCompetitiveExam({});
            setSyTypeCompetitiveExam(null);
            if (inputRefCompetitiveExam.current) {
                inputRefCompetitiveExam.current.value = '';
            }

            Swal.fire({ text: response.data.message });
        } catch (error) {
            if (error instanceof ZodError) {
                setErrorsCompetitiveExam(error.errors);
            } else {
                // Handle other errors, including network errors
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire({ text: errorMsg });
            }
        } finally {
            setLoading(false);
        }
    };

    const handleInputResetCompetitiveExam = () => {
        setExamCreateDataCompetitiveExam(initialCompetitiveExamPatterState);
        setQuestionListCompetitiveExam([]);
        setSyTypeCompetitiveExam();
        setQuestionListCompetitiveExam([]);
        setCompetitiveExamNameList([]);
        setCompetitiveExamBookList([])
        setSubjectListCompetitiveExam([]);
        setLessonListCompetitiveExam([]);
        setTopicListCompetitiveExam([]);
        setSubtopicListCompetitiveExam([]);
        setErrorsCompetitiveExam([]);
        inputRefCompetitiveExam.current.value = '';
    }


    const handleInputReset = () => {
        setExamCreateData(initialExamPatternState);
        setSyType();
        setQuestionList([]);
        setSyllabusList([]);
        setSubjectList([]);
        setLessonList([]);
        setTopicList([]);
        setSubtopicList([]);
        setAddedQuestions([]);
        setShowAddedTextBookQuestion(false);
        setIsMulti("N");
        setErrors([]);
        setErrorQuestions({})
        inputRef.current.value = null;
    }





    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Upload Exam</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-file-circle-check"></i>Upload Exam </b></h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6 view_content_radio_btn">
                                                    <label for="isMulti" className="col-form-label"><span style={{ color: "red" }}>*</span>Choose Subject Type :</label>
                                                    <label>
                                                        <input type="radio" name="isMulti" value={true} checked={examType ? isMulti === "N" : isMultiCompetitive === "N"} onChange={() => { examType ? setIsMulti("N") : setIsMultiCompetitive("N") }} /> &nbsp;Single Subject
                                                    </label>
                                                    <label>
                                                        <input type="radio" name="isMulti" value={false} checked={examType ? isMulti === "Y" : isMultiCompetitive === "Y"} onChange={() => { examType ? setIsMulti("Y") : setIsMultiCompetitive("Y") }} /> &nbsp;Multiple Subject
                                                    </label>
                                                </div>
                                                <div className="col-md-3">
                                                    <button className={`${examType ? 'active' : ''} btn btn-light btn-width`} onClick={() => setExamType(true)}>Upload Text Book Exam</button>
                                                </div>
                                                <div className="col-md-3">
                                                    <button className={`${examType ? '' : 'active'} btn btn-light btn-width`} onClick={() => setExamType(false)}>Upload Competitive Exam</button>
                                                </div>
                                            </div>

                                            {examType === true && <div className="row">
                                                <div className="col-md-6">
                                                    <label for="examName" className="col-form-label"><span style={{ color: "red" }}>*</span>Exam Name :</label>
                                                    <input type="text" className="form-control" id={`examName`} name='exam_name' onChange={(e) => handleInputChange(e)} value={examCreateData.exam_name} />
                                                    <ErrorMessage errors={errors} field="exam_name" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="description" className="col-form-label"><span style={{ color: "red" }}>*</span>Description :</label>
                                                    <input type="text" className="form-control" id={`description`} name='description' onChange={(e) => handleInputChange(e)} value={examCreateData.description} />
                                                    <ErrorMessage errors={errors} field="description" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <select class="form-select" aria-label="Default select example" name='class_id' onChange={handleClassChange} disabled={examCreateData.class_id.length !== 0} value={examCreateData.class_id}>
                                                        <option selected value={''} disabled>Select Class</option>
                                                        {
                                                            classList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.gradeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={errors} field="class_id" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Syllabus Structure :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='syllabus_structure_id' onChange={handleSyllabusChange} disabled={examCreateData.syllabus_structure_id.length !== 0 && examCreateData.syllabus_structure_type.length !== 0} value={examCreateData.syllabus_structure_id + syType}>
                                                        <option selected value={''} >Select Syllabus</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option style={{ color: syllabus.type == "I" ? "blue" : syllabus.type == "B" ? "red" : '' }} value={syllabus.id + syllabus.type}>{syllabus?.syllabusStructureName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={errors} field="syllabus_structure_id" />
                                                </div>

                                                {syType == "B" && <>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='subject_id' onChange={handleSubjectChange} disabled={isMulti === "N" ? examCreateData.subject_id.length !== 0 : false} value={examCreateData?.subject_id}>
                                                            <option selected value={''} disabled>Select Subject</option>
                                                            {
                                                                subjectList?.map((syllabus) => {
                                                                    const { id, subjectName } = syllabus?.instituteSubjectMasterDetails;
                                                                    return <option key={id} value={id} data-subject-name={subjectName}>{subjectName}</option>
                                                                })
                                                            }
                                                        </select>
                                                        <ErrorMessage errors={errors} field="subject_id" />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label for="lesson_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='lesson_id' onChange={handleLessonChange} value={examCreateData.lesson_id}>
                                                            <option selected value={''} disabled>Select Lesson</option>
                                                            {
                                                                lessonList?.map((lesson) => {
                                                                    const { id, sectionLessonName } = lesson; // Extract id and sectionLessonName
                                                                    return <option key={id} value={id} data-lesson-name={sectionLessonName}>{sectionLessonName}</option>
                                                                })
                                                            }
                                                        </select>
                                                        <ErrorMessage errors={errors} field="lesson_id" />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label">Select Topic :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='topic_id' onChange={handleTopicChange} value={examCreateData.topic_id}>
                                                            <option selected value={''} disabled>Select Topic</option>
                                                            {
                                                                topicList?.map((topic) => {
                                                                    const { id, sectionTopicName } = topic; // Extract id and sectionTopicName
                                                                    return <option key={id} value={id} data-topic-name={sectionTopicName}>{sectionTopicName}</option>
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label">Select Sub Topic :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='subtopic_id' onChange={handleInputChange} value={examCreateData.subtopic_id}>
                                                            <option selected value={''} disabled>Select Sub Topic</option>
                                                            {
                                                                subtopicList?.map((subtopic) => {
                                                                    const { id, sectionSubTopicName } = subtopic;
                                                                    return <option key={id} value={id} data-subtopic-name={sectionSubTopicName}>{sectionSubTopicName}</option>
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </>}

                                                {syType == "I" && <>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='subject_id' onChange={handleSubjectChange} disabled={isMulti === "N" ? examCreateData.subject_id.length !== 0 : false} value={examCreateData?.subject_id}>
                                                            <option selected value={''} disabled>Select Subject</option>
                                                            {
                                                                subjectList?.map((syllabus) => {
                                                                    const { id, subjectName } = syllabus?.instituteSubjectMasterDetails;
                                                                    return <option key={id} value={id} data-subject-name={subjectName}>{subjectName}</option>
                                                                })
                                                            }
                                                        </select>
                                                        <ErrorMessage errors={errors} field="subject_id" />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='lesson_id' onChange={handleLessonChange} value={examCreateData.lesson_id}>
                                                            <option selected value={''} disabled>Select Lesson</option>
                                                            {
                                                                lessonList?.map((lesson) => {
                                                                    const { id, instituteLessonName } = lesson;
                                                                    return <option key={id} value={id} data-lesson-name={instituteLessonName}>{instituteLessonName}</option>
                                                                })
                                                            }
                                                        </select>
                                                        <ErrorMessage errors={errors} field="lesson_id" />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label">Select Topic :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='topic_id' onChange={handleTopicChange} value={examCreateData.topic_id}>
                                                            <option selected value={''} disabled>Select Topic</option>
                                                            {
                                                                topicList?.map((topic) => {
                                                                    const { id, instituteTopicName } = topic;
                                                                    return <option key={id} value={id} data-topic-name={instituteTopicName}>{instituteTopicName}</option>
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label">Select Sub Topic :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='subtopic_id' onChange={handleInputChange} value={examCreateData.subtopic_id}>
                                                            <option selected value={''} disabled>Select Sub Topic</option>
                                                            {
                                                                subtopicList?.map((subtopic) => {
                                                                    const { id, instituteSubTopicName } = subtopic;
                                                                    return <option key={id} value={id} data-subtopic-name={instituteSubTopicName}>{instituteSubTopicName}</option>
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </>}

                                                {syType == "A" && <>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='subject_id' onChange={handleSubjectChange} disabled={isMulti === "N" ? examCreateData.subject_id.length !== 0 : false} value={examCreateData?.subject_id}>
                                                            <option selected value={''}>Select Subject</option>
                                                            {
                                                                subjectList?.map((syllabus) => {
                                                                    const { id, subjectName } = syllabus?.subjectMasterDetails;
                                                                    return <option key={id} value={id} data-subject-name={subjectName}>{subjectName}</option>
                                                                })
                                                            }
                                                        </select>
                                                        <ErrorMessage errors={errors} field="subject_id" />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='lesson_id' onChange={handleLessonChange} value={examCreateData.lesson_id}>
                                                            <option selected value={''} disabled>Select Lesson</option>
                                                            {
                                                                lessonList?.map((lesson) => {
                                                                    const { id, lessonName } = lesson;
                                                                    return <option key={id} value={id} data-lesson-name={lessonName}>{lessonName}</option>
                                                                })
                                                            }
                                                        </select>
                                                        <ErrorMessage errors={errors} field="lesson_id" />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label">Select Topic :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='topic_id' onChange={handleTopicChange} value={examCreateData.topic_id}>
                                                            <option selected value={''} disabled>Select Topic</option>
                                                            {
                                                                topicList?.map((topic) => {
                                                                    const { id, topicName } = topic;
                                                                    return <option key={id} value={id} data-topic-name={topicName}>{topicName}</option>
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label">Select Sub Topic :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='subtopic_id' onChange={handleInputChange} value={examCreateData.subtopic_id}>
                                                            <option selected value={''} disabled>Select Sub Topic</option>
                                                            {
                                                                subtopicList?.map((subtopic) => {
                                                                    const { id, subTopicName } = subtopic;
                                                                    return <option key={id} value={id} data-subtopic-name={subTopicName}>{subTopicName}</option>
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </>}

                                                <div className="col-md-6">
                                                    <label for="examName" className="col-form-label"><span style={{ color: "red" }}>*</span>Upload Exam Question :<span style={{ color: "red" }}>only xlsx & docx file supported </span></label>
                                                    <input type="file" className="form-control" id={`importFile`} name='importFile' onChange={(e) => handleUploadQuestion(e)} disabled={examCreateData.lesson_id.length === 0 || (examCreateData.questions.length !== 0 && addedQuestions.length !== 0)} value={examCreateData?.importFile?.name} ref={inputRef} />
                                                    <a download href='https://api.examninja.co.in/files/question-bank-import-ex.xlsx'>Sample xlsx file</a>&nbsp;
                                                    <a download href='https://api.examninja.co.in/files/SampleDoc.docx'>Sample docx file</a>

                                                    <ErrorMessage errors={errors} field="importFile" />
                                                </div>

                                                <div className="btn-sticky col-md-12 mt-3" style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
                                                    <button className="btn btn-primary" style={{ flex: '1', padding: '10px', marginRight: '10px' }} type="button"
                                                        disabled={examCreateData.questions.length === 0 || (showAddedTextBookQuestion === true && showAddedTextBookQuestion !== 0)}
                                                        onClick={() => setShowAddedTextBookQuestion(true)}
                                                    >
                                                        Added Question
                                                    </button>
                                                    <button className="btn btn-secondary" style={{ flex: '1', padding: '10px', marginRight: '10px' }} type="button" disabled={showAddedTextBookQuestion === false} onClick={() => setShowAddedTextBookQuestion(false)}>
                                                        Return
                                                    </button>
                                                    <button className="btn btn-success" style={{ flex: '1', padding: '10px', marginRight: '10px' }} type="button" onClick={createTextBookExam}>Save</button>
                                                    <button className="btn btn-danger" style={{ flex: '1', padding: '10px' }} type="button" onClick={handleInputReset}>Reset</button>
                                                </div>

                                                {examCreateData.syllabus_structure_id !== "" && showAddedTextBookQuestion === false &&
                                                    <div className="d-grid gap-2 mt-2">
                                                        <div class="tab-content rounded-bottom custom_table custom_table_width">
                                                            <div class="tab-pane p-3 active prefilter" role="tabpanel" id="prefilter-1000">
                                                                <div>
                                                                    {errorQuestions.errorCount > 0 && (
                                                                        <div className="alert alert-danger" role="alert">
                                                                            {errorQuestions.errorCount === 1 ?
                                                                                `There is ${errorQuestions.errorCount} invalid or empty question` :
                                                                                `There are ${errorQuestions.errorCount} invalid or empty questions`
                                                                            }
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                {questionList.length > 0 && <ErrorMessage errors={errors} field="questions" />}
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            {questionList?.length > 0 && <th scope="col">
                                                                                <input
                                                                                    type='checkbox'
                                                                                    checked={areAllQuestionsSelected(questionList, addedQuestions)}
                                                                                    onClick={() => handleSelectAllClick(questionList, examCreateData, setExamCreateData, addedQuestions, setAddedQuestions)}
                                                                                /> All
                                                                            </th>}
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope='col'>Q_Level</th>
                                                                            <th scope='col'>Q_Type</th>
                                                                            <th scope='col'>Question</th>
                                                                            <th scope="col">Option_a</th>
                                                                            <th scope="col">Option_b </th>
                                                                            <th scope="col">Option_c</th>
                                                                            <th scope="col">Option_d</th>
                                                                            <th scope='col'>Answer</th>
                                                                            <th scope='col'>Solution</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            questionList?.length > 0 ?
                                                                                questionList?.map((question, index) => {
                                                                                    <QuestionFilter key={index} question={question}></QuestionFilter>
                                                                                    const rowClass = isErrorUploadExamQuestion(errorQuestions, question) ? 'error-row' : '';
                                                                                    return (
                                                                                        <tr key={index} className={rowClass}>
                                                                                            <td>
                                                                                                <input type='checkbox' checked={isQuestionSelected(question, addedQuestions)}
                                                                                                    onChange={() => (
                                                                                                        isQuestionIdPresent(question.q_id, examCreateData) ?
                                                                                                            removeQuestion(question.q_id, setExamCreateData, setAddedQuestions)
                                                                                                            :
                                                                                                            handleAddSingleQuestion(question, examCreateData, setExamCreateData, addedQuestions, setAddedQuestions)
                                                                                                    )}
                                                                                                />
                                                                                            </td>
                                                                                            <th scope="row" className='sl_no'>{index + 1}</th>
                                                                                            <td>{question.q_level}</td>
                                                                                            <td>{question.q_type}</td>
                                                                                            <ViewImageAndText inputString={question.question} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.option_a} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.option_b} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.option_c} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.option_d} onViewImage={onViewImage} />
                                                                                            <td>{question.ans}</td>
                                                                                            <td>
                                                                                                <button className="btn btn-primary view_icon mt-1" type="button" onClick={() => {
                                                                                                    setVisible(!visible)
                                                                                                    setModalData(question.sol)
                                                                                                }}><i class="fa fa-eye"></i></button>
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }

                                                {showAddedTextBookQuestion === true &&
                                                    <div className="d-grid gap-2 mt-2">
                                                        <div class="tab-content rounded-bottom custom_table custom_table_width">
                                                            <div class="tab-pane p-3 active prefilter" role="tabpanel" id="prefilter-1000">
                                                                <div>
                                                                    {errorQuestions.errorCount > 0 && (
                                                                        <div className="alert alert-danger" role="alert">
                                                                            {errorQuestions.errorCount === 1 ?
                                                                                `There is ${errorQuestions.errorCount} invalid or empty question` :
                                                                                `There are ${errorQuestions.errorCount} invalid or empty questions`
                                                                            }
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            {/* {addedQuestions?.length > 0 && <th scope="col">
                                                                                <input
                                                                                    type='checkbox'
                                                                                    checked={addedQuestions.length > 0}
                                                                                    onClick={() => handleSelectAllClickTextBookQuestion()}
                                                                                /> All
                                                                            </th>} */}
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope='col'>Subject</th>
                                                                            <th scope='col'>Lesson</th>
                                                                            <th scope='col'>Topic</th>
                                                                            <th scope='col'>SubTopic</th>
                                                                            <th scope="col">Question</th>
                                                                            <th scope='col'>Solution</th>
                                                                            <th scope='col'>Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            addedQuestions?.length > 0 ?
                                                                                addedQuestions?.map((question, index) => {
                                                                                    const rowClass = isErrorUploadExamQuestion(errorQuestions, question) ? 'error-row' : '';
                                                                                    return (
                                                                                        <tr key={index} className={rowClass}>
                                                                                            {/* <td><input type='checkbox' checked={isQuestionSelected(question, addedQuestions)} onChange={() => (removeQuestion(question.q_id))} /></td> */}
                                                                                            <th scope="row" className='sl_no'>{index + 1}</th>
                                                                                            <td>{question.subjectName}</td>
                                                                                            <td>{question.lessonName}</td>
                                                                                            <td>{question.topicName}</td>
                                                                                            <td>{question.subtopicName}</td>
                                                                                            <ViewImageAndText inputString={question.question} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.sol} onViewImage={onViewImage} />
                                                                                            <td>
                                                                                                <button className="btn btn-outline-danger delete_icon" type="button" onClick={() => deleteQuestion(question.q_id, setExamCreateData, setAddedQuestions)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>}

                                            {examType === false && <div className="row">
                                                <div className="col-md-6">
                                                    <label for="examName" className="col-form-label"><span style={{ color: "red" }}>*</span>Exam Name :</label>
                                                    <input type="text" className="form-control" id={`examName`} name='exam_name' onChange={handleInputChangeCompetitiveExam} value={examCreateDataCompetitiveExam.exam_name} />
                                                    <ErrorMessage errors={errorsCompetitiveExam} field="exam_name" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="description" className="col-form-label"><span style={{ color: "red" }}>*</span>Description :</label>
                                                    <input type="text" className="form-control" id={`description`} name='description' onChange={handleInputChangeCompetitiveExam} value={examCreateDataCompetitiveExam.description} />
                                                    <ErrorMessage errors={errorsCompetitiveExam} field="description" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <select class="form-select" aria-label="Default select example" name='class_id' onChange={handleClassChangeCompetitveExam} disabled={examCreateDataCompetitiveExam.class_id.length !== 0} value={examCreateDataCompetitiveExam.class_id}>
                                                        <option selected value={''} disabled>Select Class</option>
                                                        {
                                                            classList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.gradeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={errorsCompetitiveExam} field="class_id" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="competitive_exam_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Competitive Exam :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='competitive_exam_id' onChange={handleCompetitiveExamNameChange} disabled={examCreateDataCompetitiveExam.competitive_exam_id.length !== 0} value={examCreateDataCompetitiveExam.competitive_exam_id + syTypeCompetitiveExam}>
                                                        <option selected value={''} >Select Competitive Exam</option>
                                                        {
                                                            competitiveExamNameList?.map((competitiveExamName) => {
                                                                return <option style={{ color: competitiveExamName.type == "I" ? "blue" : competitiveExamName.type == "B" ? "red" : '' }} value={competitiveExamName.id + competitiveExamName.type}>{competitiveExamName?.examName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={errorsCompetitiveExam} field="competitive_exam_id" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="book_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Book :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='book_id' onChange={handleCompetitiveExamBookChange} disabled={examCreateDataCompetitiveExam.book_id.length !== 0} value={examCreateDataCompetitiveExam.book_id}>
                                                        <option selected value={''} disabled>Select Book</option>
                                                        {
                                                            competitiveExamBookList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.bookName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={errorsCompetitiveExam} field="book_id" />
                                                </div>

                                                {syTypeCompetitiveExam == "I" && <>
                                                    <div className="col-md-6">
                                                        <label for="subject_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='subject_id' onChange={handleSubjectChangeCompetitiveExam} disabled={isMultiCompetitive === "N" ? examCreateDataCompetitiveExam.subject_id.length !== 0 : false} value={examCreateDataCompetitiveExam?.subject_id}>
                                                            <option selected value={''} disabled>Select Subject</option>
                                                            {
                                                                subjectListCompetitiveExam?.map((syllabus) => {
                                                                    const { id, subjectName } = syllabus?.instituteSubjectMasterDetails;
                                                                    return <option key={id} value={id} data-subject-name={subjectName}>{subjectName}</option>
                                                                })
                                                            }
                                                        </select>
                                                        <ErrorMessage errors={errorsCompetitiveExam} field="subject_id" />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label for="lesson_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='lesson_id' onChange={handleCompetitiveExamLessonChange} value={examCreateDataCompetitiveExam.lesson_id}>
                                                            <option selected value={''} disabled>Select Lesson</option>
                                                            {
                                                                lessonListCompetitiveExam?.map((lesson) => {
                                                                    const { id, competitiveLessonName } = lesson;
                                                                    return <option key={id} value={id} data-lesson-name={competitiveLessonName}>{competitiveLessonName}</option>
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label for="topic_id" className="col-form-label">Select Topic :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='topic_id' onChange={handleCompetitiveExamTopicChange} value={examCreateDataCompetitiveExam.topic_id}>
                                                            <option selected value={''} disabled>Select Topic</option>
                                                            {
                                                                topicListCompetitiveExam?.map((topic) => {
                                                                    const { id, competitiveTopicName } = topic;
                                                                    return <option key={id} value={id} data-topic-name={competitiveTopicName}>{competitiveTopicName}</option>
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label for="subtopic_id" className="col-form-label">Select Sub Topic :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='subtopic_id' onChange={handleInputChange} value={examCreateData.subtopic_id}>
                                                            <option selected value={''} disabled>Select Sub Topic</option>
                                                            {
                                                                subtopicListCompetitiveExam?.map((subtopic) => {
                                                                    const { id, competitiveSubTopicName } = subtopic;
                                                                    return <option key={id} value={id} data-subtopic-name={competitiveSubTopicName}>{competitiveSubTopicName}</option>
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </>}

                                                {syTypeCompetitiveExam == "A" && <>
                                                    <div className="col-md-6">
                                                        <label for="subject_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='subject_id' onChange={handleSubjectChangeCompetitiveExam} disabled={isMultiCompetitive === "N" ? examCreateDataCompetitiveExam.subject_id.length !== 0 : false} value={examCreateDataCompetitiveExam?.subject_id}>
                                                            <option selected value={''} disabled>Select Subject</option>
                                                            {
                                                                subjectListCompetitiveExam?.map((subject) => {
                                                                    const { id, subjectName } = subject?.subjectMasterDetails;
                                                                    return <option key={id} value={id} data-subject-name={subjectName}>{subjectName}</option>
                                                                })
                                                            }
                                                        </select>
                                                        <ErrorMessage errors={errorsCompetitiveExam} field="subject_id" />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label for="lesson_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='lesson_id' onChange={handleCompetitiveExamLessonChange} value={examCreateDataCompetitiveExam.lesson_id}>
                                                            <option selected value={''} disabled>Select Lesson</option>
                                                            {
                                                                lessonListCompetitiveExam?.map((lesson) => {
                                                                    const { id, competitiveLessonName } = lesson;
                                                                    return <option key={id} value={id} data-lesson-name={competitiveLessonName}>{competitiveLessonName}</option>
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label for="topic_id" className="col-form-label">Select Topic :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='topic_id' onChange={handleCompetitiveExamTopicChange} value={examCreateDataCompetitiveExam.topic_id}>
                                                            <option selected value={''} disabled>Select Topic</option>
                                                            {
                                                                topicListCompetitiveExam?.map((topic) => {
                                                                    const { id, competitiveTopicName } = topic;
                                                                    return <option key={id} value={id} data-topic-name={competitiveTopicName}>{competitiveTopicName}</option>
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label for="subtopic_id" className="col-form-label">Select Sub Topic :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='subtopic_id' onChange={handleInputChange} value={examCreateDataCompetitiveExam.subtopic_id}>
                                                            <option selected value={''} disabled>Select Sub Topic</option>
                                                            {
                                                                subtopicListCompetitiveExam?.map((subtopic) => {
                                                                    const { id, competitiveSubTopicName } = subtopic;
                                                                    return <option key={id} value={id} data-subtopic-name={competitiveSubTopicName}>{competitiveSubTopicName}</option>
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </>}

                                                <div className="col-md-6">
                                                    <label for="examName" className="col-form-label"><span style={{ color: "red" }}>*</span>Upload Exam Question :<span style={{ color: "red" }}>only xlsx & docx file supported </span></label>
                                                    <input type="file" className="form-control" id={`importFile`} name='importFile' onChange={(e) => handleUploadCompetitiveQuestion(e)} disabled={examCreateDataCompetitiveExam.lesson_id.length === 0 || (examCreateDataCompetitiveExam.questions.length !== 0 && addedCompetitiveQuestions.length !== 0)} value={examCreateDataCompetitiveExam?.importFile?.name} ref={inputRefCompetitiveExam} />
                                                    <a download href='https://api.examninja.co.in/files/question-bank-import-ex.xlsx'>Sample xlsx file</a>&nbsp;
                                                    <a download href='https://api.examninja.co.in/files/SampleDoc.docx'>Sample docx file</a>
                                                    <ErrorMessage errors={errorsCompetitiveExam} field="importFile" />
                                                </div>

                                                <div className="btn-sticky col-md-12 mt-3" style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
                                                    <button className="btn btn-primary" style={{ flex: '1', padding: '10px', marginRight: '10px' }} type="button"
                                                        disabled={examCreateDataCompetitiveExam.questions.length === 0 || (showAddedCompetitiveQuestion === true && showAddedCompetitiveQuestion !== 0)}
                                                        onClick={() => setShowAddedCompetitiveQuestion(true)}
                                                    >
                                                        Added Question
                                                    </button>
                                                    <button className="btn btn-secondary" style={{ flex: '1', padding: '10px', marginRight: '10px' }} type="button" disabled={showAddedCompetitiveQuestion === false} onClick={() => setShowAddedCompetitiveQuestion(false)}>
                                                        Return
                                                    </button>
                                                    <button className="btn btn-success" style={{ flex: '1', padding: '10px', marginRight: '10px' }} type="button" onClick={createCompetitiveExam}>Save</button>
                                                    <button className="btn btn-danger" style={{ flex: '1', padding: '10px' }} type="button" onClick={handleInputResetCompetitiveExam}>Reset</button>
                                                </div>

                                                {examCreateDataCompetitiveExam.competitive_exam_id !== "" && showAddedCompetitiveQuestion === false &&
                                                    <div className="d-grid gap-2 mt-2">
                                                        <div class="tab-content rounded-bottom custom_table custom_table_width">
                                                            <div class="tab-pane p-3 active prefilter" role="tabpanel" id="prefilter-1000">
                                                                <div>
                                                                    {errorQuestionsCompetitiveExam.errorCount > 0 && (
                                                                        <div className="alert alert-danger" role="alert">
                                                                            {errorQuestionsCompetitiveExam.errorCount === 1 ?
                                                                                `There is ${errorQuestionsCompetitiveExam.errorCount} invalid or empty question` :
                                                                                `There are ${errorQuestionsCompetitiveExam.errorCount} invalid or empty questions`
                                                                            }
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                {questionListCompetitiveExam.length > 0 && <ErrorMessage errors={errorsCompetitiveExam} field="questions" />}
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            {questionListCompetitiveExam?.length > 0 && <th scope="col">
                                                                                <input
                                                                                    type='checkbox'
                                                                                    checked={areAllQuestionsSelected(questionListCompetitiveExam, addedCompetitiveQuestions)}
                                                                                    onClick={() => handleSelectAllClick(questionList, examCreateDataCompetitiveExam, setExamCreateDataCompetitiveExam, addedCompetitiveQuestions, setAddedCompetitiveQuestions)}
                                                                                /> All
                                                                            </th>}
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope='col'>Q_Level</th>
                                                                            <th scope='col'>Q_Type</th>
                                                                            <th scope='col'>Question</th>
                                                                            <th scope="col">Option_a</th>
                                                                            <th scope="col">Option_b </th>
                                                                            <th scope="col">Option_c</th>
                                                                            <th scope="col">Option_d</th>
                                                                            <th scope='col'>Answer</th>
                                                                            <th scope='col'>Solution</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            questionListCompetitiveExam?.length > 0 ?
                                                                                questionListCompetitiveExam?.map((question, index) => {
                                                                                    <QuestionFilter key={index} question={question}></QuestionFilter>
                                                                                    const rowClass = isErrorUploadExamQuestion(errorQuestionsCompetitiveExam, question) ? 'error-row' : '';
                                                                                    return (
                                                                                        <tr key={index} className={rowClass}>
                                                                                            <td>
                                                                                                <input type='checkbox' checked={isQuestionSelected(question, addedCompetitiveQuestions)}
                                                                                                    onChange={() => (
                                                                                                        isQuestionIdPresent(question.q_id, examCreateDataCompetitiveExam) ?
                                                                                                            removeQuestion(question.q_id, setExamCreateDataCompetitiveExam, setAddedCompetitiveQuestions)
                                                                                                            :
                                                                                                            handleAddSingleQuestion(question, examCreateDataCompetitiveExam, setExamCreateDataCompetitiveExam, addedCompetitiveQuestions, setAddedCompetitiveQuestions)
                                                                                                    )}
                                                                                                />
                                                                                            </td>
                                                                                            <th scope="row" className='sl_no'>{index + 1}</th>
                                                                                            <td>{question.q_level}</td>
                                                                                            <td>{question.q_type}</td>
                                                                                            <ViewImageAndText inputString={question.question} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.option_a} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.option_b} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.option_c} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.option_d} onViewImage={onViewImage} />
                                                                                            <td>{question.ans}</td>
                                                                                            <td>
                                                                                                <button className="btn btn-primary view_icon mt-1" type="button" onClick={() => {
                                                                                                    setVisible(!visible)
                                                                                                    setModalData(question.sol);
                                                                                                }}><i className="fa fa-eye"></i></button>
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }

                                                {showAddedCompetitiveQuestion === true &&
                                                    <div className="d-grid gap-2 mt-2">
                                                        <div class="tab-content rounded-bottom custom_table custom_table_width">
                                                            <div class="tab-pane p-3 active prefilter" role="tabpanel" id="prefilter-1000">
                                                                <div>
                                                                    {errorQuestionsCompetitiveExam.errorCount > 0 && (
                                                                        <div className="alert alert-danger" role="alert">
                                                                            {errorQuestionsCompetitiveExam.errorCount === 1 ?
                                                                                `There is ${errorQuestionsCompetitiveExam.errorCount} invalid or empty question` :
                                                                                `There are ${errorQuestionsCompetitiveExam.errorCount} invalid or empty questions`
                                                                            }
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            {/* {addedQuestions?.length > 0 && <th scope="col">
                                                                                <input
                                                                                    type='checkbox'
                                                                                    checked={addedQuestions.length > 0}
                                                                                    onClick={() => handleSelectAllClickTextBookQuestion()}
                                                                                /> All
                                                                            </th>} */}
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope='col'>Subject</th>
                                                                            <th scope='col'>Lesson</th>
                                                                            <th scope='col'>Topic</th>
                                                                            <th scope='col'>SubTopic</th>
                                                                            <th scope="col">Question</th>
                                                                            <th scope='col'>Solution</th>
                                                                            <th scope='col'>Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            addedCompetitiveQuestions?.length > 0 ?
                                                                                addedCompetitiveQuestions?.map((question, index) => {
                                                                                    const rowClass = isErrorUploadExamQuestion(errorQuestionsCompetitiveExam, question) ? 'error-row' : '';
                                                                                    return (
                                                                                        <tr key={index} className={rowClass}>
                                                                                            {/* <td><input type='checkbox' checked={isQuestionSelected(question, addedQuestions)} onChange={() => (removeQuestion(question.q_id))} /></td> */}
                                                                                            <th scope="row" className='sl_no'>{index + 1}</th>
                                                                                            <td>{question.subjectName}</td>
                                                                                            <td>{question.lessonName}</td>
                                                                                            <td>{question.topicName}</td>
                                                                                            <td>{question.subtopicName}</td>
                                                                                            <ViewImageAndText inputString={question.question} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.sol} onViewImage={onViewImage} />
                                                                                            <td>
                                                                                                <button className="btn btn-outline-danger delete_icon" type="button" onClick={() => deleteQuestion(question.q_id, setExamCreateDataCompetitiveExam, setAddedCompetitiveQuestions)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }

                                            </div>}
                                        </div>

                                        {visible && <SolutionModal visibleSolution={visible} setVisibleSolution={setVisible} modalData={modalData} />}

                                        {visibleImage && <ImageModal visibleImage={visibleImage} setVisibleImage={setVisibleImage} modalImageSrc={modalImageSrc} />}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default ExamUpload;